/* ============================================================
   bl_menu-masonry.js — row-first masonry packing for mega-menu
   link columns (the "Masonry — fill by row" arrangement).

   Progressive enhancement, and only where it's needed:
     • Browsers with native CSS grid masonry pack the row-first grid
       themselves (see @supports in bl_component-megamenu.css) — this
       script detects that and does nothing.
     • Browsers without it (e.g. Chrome) fall back to an aligned grid
       in pure CSS; this script upgrades that to a packed masonry by
       sizing each block with `grid-row: span N`.
     • If this script never runs (JS disabled), the aligned-grid CSS
       fallback still renders — row-first, just not packed.

   Contract with bl_component-megamenu.css:
     • Targets .bl-megamenu__grid--masonry-row.
     • Adds .bl-mmr-js, which switches the grid to grid-auto-rows:1px /
       row-gap:0 so a span count equals a pixel height.
     • ROW_GAP below MUST match the CSS base row-gap (26px): the script
       bakes the gap into each span since row-gap is zeroed.
     • .bl-megamenu__col uses align-self:start, so a block's measured
       height is its content height regardless of the span already set.
   ============================================================ */
(function () {
  'use strict';

  var GRID_SELECTOR = '.bl-megamenu__grid--masonry-row';
  var ITEM_SELECTOR = '.bl-megamenu__col';
  var ROW_UNIT = 1;   // px per implicit row (grid-auto-rows: 1px)
  var ROW_GAP = 26;   // must match CSS base row-gap for --masonry-row

  // Native CSS grid masonry handles the packing on its own — bail out.
  if (window.CSS && CSS.supports && CSS.supports('grid-template-rows', 'masonry')) {
    return;
  }

  // No ResizeObserver → we can't reliably detect the menu opening; skip the
  // JS packing and leave the CSS aligned-grid fallback in place.
  if (typeof window.ResizeObserver === 'undefined') {
    return;
  }

  function layout(grid) {
    // Hidden (menu closed) or not yet laid out — can't measure, leave as-is.
    if (!grid.clientWidth) {
      return;
    }

    var items = grid.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) {
      return;
    }

    // Two passes: measure every block's content height first, then apply the
    // spans, so setting one span never perturbs a later measurement.
    var heights = new Array(items.length);
    var i;
    for (i = 0; i < items.length; i++) {
      heights[i] = items[i].getBoundingClientRect().height;
    }
    for (i = 0; i < items.length; i++) {
      var span = Math.ceil((heights[i] + ROW_GAP) / ROW_UNIT);
      items[i].style.gridRowEnd = 'span ' + span;
    }
  }

  function observe(grid) {
    grid.classList.add('bl-mmr-js');

    var frame = null;
    var run = function () {
      frame = null;
      layout(grid);
    };
    var schedule = function () {
      if (frame === null) {
        frame = window.requestAnimationFrame(run);
      }
    };

    // Fires when the menu opens (0 → real size) and on any resize/reflow.
    var ro = new ResizeObserver(schedule);
    ro.observe(grid);

    layout(grid); // in case it is already visible on load
  }

  function init() {
    var grids = document.querySelectorAll(GRID_SELECTOR);
    for (var i = 0; i < grids.length; i++) {
      observe(grids[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
